import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ToolbarComponent } from './shell/toolbar/toolbar.component';
import { MenuComponent } from './shell/menu/menu.component';

import { TitleService } from './services/title.service';
import { AuthService } from './auth/auth.service';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatIconModule, MatSidenavModule, ToolbarComponent, MenuComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [TitleService]
})
export class AppComponent implements AfterViewInit {
  loading: boolean = true;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}
  title = 'CrossoverPlus';
  @ViewChild('scrollContainer', { static: false }) private scroller!: ElementRef;
  ngAfterViewInit(): void {
    this.checkAuthenticationStatus();
  }

  private async checkAuthenticationStatus(): Promise<void> {
    try {
      const user = await firstValueFrom(this.authService.getUser());
      if (user) {
        this.loading = false;
      } else {
        this.redirectToLogin();
      }
    } catch (error) {
      this.redirectToLogin();
    }
  }

  private redirectToLogin(): void {
    window.location.href = environment.loginUrl;
  }

  observeIntersection(callback: IntersectionObserverCallback, options?: IntersectionObserverInit): IntersectionObserver {
    if (!this.scroller) {
      console.error('Scroller element is not defined');
      throw new Error('Scroller element is not defined');
    }
    if (!this.scroller.nativeElement) {
      console.error('Scroller nativeElement is not defined');
      throw new Error('Scroller nativeElement is not defined');
    }
    return new IntersectionObserver(callback, {
      ...options,
      root: this.scroller.nativeElement
    });
  }
}
